import request from '@/service/request'

/* 转专业，分页
* @params {string} campusId 校区
* @params {string} grade 年级
* */
export const pageMajorTransferRecordApi = (params) => {
  return request.post('/stu/stuMajorChange/page', params)
}
